// import _ from "lodash";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import InputBox from "components/form/input/InputBox";
import { PField } from "components/form/input/NestedField";
import { fieldHasError, requiredValidator } from "components/form/input/validator";
import getGruposPermissao from "entity/GrupoPermissao";
import { useState } from "react";

export default function SelectGrupoPermissao({
    name = "grupoPermissao",
    label = "Grupo Permissão",

    initialValue,
    required,
    helperText,
    sx,
    children,
    ...props
}) {
    const [open, setOpen] = useState(false)

    // const labelId = _.uniqueId(name);
    // { uid: "r9jrEQXznNgjrZTGCfch", nome: "Administrador" },
    // { uid: "RECT03jkyTQW9B2OMz47", nome: "Técnico" },
    // { uid: "fsMA3C4KiqrssZoJoL6N", nome: "Cliente" }
    const options = getGruposPermissao()
    const labelField = "nome"
    return (
        <InputBox sx={sx}>
            <PField name={name} initialValue={initialValue} validate={required ? requiredValidator : null}>
                {(fieldProps) => {
                    const hasError = fieldHasError(fieldProps.meta);

                    return (
                        <FormControl required={required} error={hasError} variant="standard" sx={{ flex: 1 }}>

                            <Autocomplete
                                options={options}
                                getOptionLabel={(v) => v?v.nome:""}
                                isOptionEqualToValue={(option, value) => option.uid === value.uid}
                                //
                                renderOption={(props, option) =>
                                    option.uid && option[labelField] ? (
                                        <li {...props} key={option.uid}>
                                            {option?option.nome:""}
                                        </li>
                                    ) : null
                                }
                                //
                                open={open}
                                onOpen={() => setOpen(true)}
                                onClose={() => setOpen(false)}

                                //
                                sx={{ flex: 1 }}
                                forcePopupIcon={false}
                                renderInput={(params) => (
                                    <TextField
                                        label={label}
                                        required={required}
                                        error={hasError}
                                        helperText={hasError ? fieldProps.meta.error : helperText}
                                        variant="standard"
                                        {...params}

                                    />
                                )}
                                //
                                {...fieldProps.input}
                                {...props}
                                onChange={(event, value) => {
                                    // Necessário para passar os valores do MUI para o Final Form imediatamente.
                                    fieldProps.input.onChange(value);
                                }}
                            />

                        </FormControl>
                    );
                }}
            </PField>
        </InputBox>
    );
}
